import BuildInfo from '@Services/BuildInfo';
import {
  aboutContentSetUpdateInfoReducerType,
  aboutContentSetIsLoadingReducerType,
  aboutContentSetBEBuildNumberReducerType,
  aboutContentSetDatabasesReducerType,
} from './AboutContentConstants';

export function setIsLoading(isLoading) {
  return {
    type: aboutContentSetIsLoadingReducerType,
    payload: { isLoading },
  };
}

export function setBEBuildNumber(BEBuildNumber) {
  return {
    type: aboutContentSetBEBuildNumberReducerType,
    payload: BEBuildNumber,
  };
}

export function setUpdateInfo(updateInfo) {
  return {
    type: aboutContentSetUpdateInfoReducerType,
    payload: { updateInfo },
  };
}

export function setDatabases(databases) {
  return {
    type: aboutContentSetDatabasesReducerType,
    payload: { databases },
  };
}

export const init = () => {
  return async (dispatch) => {
    dispatch(setIsLoading(true));
    await BuildInfo.getBuildInfo()
      .then(({ buildNumber, databases, updateInfo }) => {
        dispatch(setBEBuildNumber(buildNumber));
        dispatch(setUpdateInfo(updateInfo.contexts));
        dispatch(setDatabases(databases));
        dispatch(setIsLoading(false));
      })
      .catch(Logger.error);
  };
};
